import { useCallback, useEffect, useState, useRef, useContext } from "react"
import { useDispatch, useStore } from "react-redux"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import htmlToDraft from "html-to-draftjs"
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from 'draft-js';

import { Table } from "rsuite"
import draftToHtml from "draftjs-to-html"
import { FcGoogle } from "react-icons/fc";
import { FaMicrosoft } from "react-icons/fa";
import { useMsal } from "@azure/msal-react";
import { useGoogleLogin } from "@react-oauth/google"
import { addEmailSignature, addVoicemail, deleteEmail, getSavedEmailsAndSettingData, updateDefaultEmail } from "../../redux/actions/settings"
import { toast } from "../CommonComponents/ToastComponent/toast"
import Select, { components } from 'react-select'
import { checkEmailIfExist, exchangeCodeForTokens, saveAuthenticatedEmail, updatePhoneNo } from "../../redux/actions/emailSettings"
import Label from "../CommonComponents/Label"
import { PiWaveform } from "react-icons/pi";
import { getTwilioPhoneNumbers } from "../../redux/actions/caller";
import { getUserInfo } from "../../redux/actions/auth";
import { AiFillDelete } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import { Modal } from 'rsuite'
import { AppContext } from "../../context";
import { CONSTANTS } from "../../utils/constants/constants";


const { Cell, Column, HeaderCell } = Table

const LinkAccount = ({
    linkOptions,
    isOpenGoogleLinkDuration,
    setIsOpenGoogleLinkDuration,
    isOpenMicrosoftLinkDuration,
    setIsOpenMicrosoftLinkDuration,
    customStyles,
    setSelectedSyncDuration,
    selectedSyncDuration,
    onAddEmails
}) => {
    return (
        (isOpenGoogleLinkDuration || isOpenMicrosoftLinkDuration) ? (
            <div className="border px-4 py-3" style={{ width: 400, height: 100, borderRadius: '5px', zIndex: 100 }}>
                <div className="d-flex justify-content-between align-items-center">
                    <h4 className="fw-bold text-black">Sync Email History</h4>
                    <Select
                        className="w-25"
                        options={linkOptions}
                        value={selectedSyncDuration || linkOptions[2]}
                        styles={customStyles}
                        onChange={(e) => { setSelectedSyncDuration(e) }}

                    />
                </div>
                <div className="mt-2">
                    <button className="btn btn-green" onClick={() => { onAddEmails() }} style={{ width: '100px' }}>Link</button>
                </div>
            </div>
        ) : null
    );
}


const Title = ({ title }) => {
    return <h3 className="fw-bold text-dark">{title}</h3>
}

const AppEmail = () => {
    const dispatch = useDispatch()
    const { instance, accounts } = useMsal();


    const store = useStore().getState()
    const {
        auth: { user },
        emailSettings: {
            emailData
        }
    } = store

    const location = useLocation();

    const linkOptions = [
        { name: 'all', label: "All" },
        { name: 'month', label: "30 days" },
        { name: 'current', label: "Today" }
    ]

     const {
        googleLogin
        } = useContext(AppContext);

    const customStyles = {
        container: (base) => ({
            ...base,
            zIndex: 3
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? 'transparent' : 'transparent', // No background on hover
            color: state.isSelected ? 'black' : 'black', // Text color for selected option
            fontSize: 14,
            cursor: 'pointer'
        }),
        control: (provided) => ({
            ...provided,
            height: 48,
            fontSize: 14,
            borderColor: 'gray', // Customize control border color
            boxShadow: 'none', // Remove the default box shadow
            '&:hover': {
                borderColor: 'gray', // Maintain border color on hover
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'black', // Text color for selected value in the control
        }),
    };


    const [email, setEmail] = useState('')
    const [voicemailMsg, setVoicemailMsg] = useState('')
    const [userAppSettingData, setUserAppSettingData] = useState({})
    const [emailDomain, setEmailDomain] = useState(null) //office365, google
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [isOpenGoogleLinkDuration, setIsOpenGoogleLinkDuration] = useState(false)
    const [isOpenMicrosoftLinkDuration, setIsOpenMicrosoftLinkDuration] = useState(false)
    const [userEmailList, setUserEmailList] = useState([])
    const [selectedRegisteredEmail, setSelectedRegisteredEmail] = useState({})
    const [selectedSyncDuration, setSelectedSyncDuration] = useState(linkOptions[1])
    const [phoneNo, setPhoneNo] = useState({})
    const [emailIdSelectedToDelete, setEmailIdSelectedToDelete] = useState(null)
    const [defaultEmail, setDefaultEmail] = useState(null)



    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const onDefaultEmailHandler = (e) => {
        setDefaultEmail(e)
        if (userEmailList?.length > 1) {
            dispatch(updateDefaultEmail(e?.value)).then(() => {
                getSavedEmailsAndSettingsDataForUser()
                toast.show({
                    title: 'Success',
                    description: 'Default Email Updated SuccessFully',
                })
            }).catch(err => {
                toast.show({
                    title: 'Warning',
                    description: 'Unable to Update Default Email',
                })
            })
        }
    }

    const onAddEmails = async () => {
        if (emailDomain === 'google') {
            dispatch(checkEmailIfExist(email)).then(async (res) => {
                if (res.status === 204) {
                    await googleLogin(false, null, [], [], null, [], 'tasks', getSavedEmailsAndSettingsDataForUser) //isReauthentication - false/true
                    getSavedEmailsAndSettingsDataForUser()
                }
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: CONSTANTS.TOAST_MESSAGES.DANGER.EMAIL_LOGIN_ERROR,
                })
            })
        } else {
            await instance.loginPopup().then(async (res) => {
                if (res?.accessToken) {
                    await dispatch(saveAuthenticatedEmail({ email: res?.account?.username, accessToken: res?.accessToken, refreshToken: null, expires_in: res?.expiresOn, domain: 'microsoft', emailSyncDuration: selectedSyncDuration?.name, isReauthenticated: false, userId: user?.id }))
                    toast.show({
                        title: 'Success',
                        description: CONSTANTS.TOAST_MESSAGES.SUCCESS.EMAIL_LOGIN_SUCCESS,
                    })
                    getSavedEmailsAndSettingsDataForUser()
                }
            }).catch((error) => {
                toast.show({
                    title: 'Warning',
                    description: CONSTANTS.TOAST_MESSAGES.DANGER.EMAIL_LOGIN_ERROR,
                })
            });

        }
    }

    let columns = [
        { label: 'Emails', name: 'email' }
    ]

    const getSavedEmailsAndSettingsDataForUser = useCallback(async () => {
        await dispatch(getSavedEmailsAndSettingData(user?.id)).then((res) => {
            let tmpList = res?.allEmails?.map((email) => {
                return {
                    value: email?.id,
                    name: email?.email,
                    label: email?.email,
                    isDefault: email?.isDefaultEmail,
                    accessToken: email?.accessToken,
                    refreshToken: email?.refreshToken,
                    domain: email?.domain,
                    emailSignature: email?.emailSignature
                }
            })
            let tmpDefaultEmail = tmpList?.filter((email) => email?.isDefault)
            setDefaultEmail(tmpDefaultEmail[0])
            setUserEmailList(tmpList)
            setSelectedRegisteredEmail(tmpDefaultEmail[0])
    
            let defaultRegisteredEmailSignature = tmpDefaultEmail[0]?.emailSignature

            if (defaultRegisteredEmailSignature) {
                const contentBlock = htmlToDraft(defaultRegisteredEmailSignature);
                if (contentBlock) {
                    const { contentBlocks, entityMap } = contentBlock;
                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                    const newEditorState = EditorState.createWithContent(contentState);
                    setEditorState(newEditorState);
                }
            }

            setUserAppSettingData(res)
        }).catch(err => {
            setUserAppSettingData({})
            toast.show({
                title: 'Warning',
                description: 'Unable To Fetch Saved Emails',
            })
        })
    }, [])

    useEffect(() => {

    }, [userEmailList])

    const headerElement = columns.map((col, index) => {
        return (
            <Column
                resizable
                sortable
                key={col.name}
                width={250}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell dataKey={col.name} />
            </Column>
        )
    })

    const onDeleteEmail = async () => {
        let emailIdToBeDefault = null
        if (userEmailList?.length === 2) {
            emailIdToBeDefault = emailIdSelectedToDelete?.isDefault ? userEmailList?.filter((email) => parseInt(email?.value) !== parseInt(emailIdSelectedToDelete?.value))[0]?.value : null
        } else if (userEmailList?.length > 2) {
            emailIdToBeDefault = emailIdSelectedToDelete?.isDefault ? parseInt(selectedOption) : null
        }

        if (!selectedOption && userEmailList?.length > 2) {
            toast.show({
                title: 'Warning',
                description: 'Please Select Your default Email',
            })
            return
        }
        await dispatch(deleteEmail(emailIdSelectedToDelete?.value, emailIdToBeDefault)).then(async () => {
            await getSavedEmailsAndSettingsDataForUser()
            toast.show({
                title: 'Success',
                description: 'Email Deleted Successfully',
            })
        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: 'Unable To Delete Email',
            })
        })

        setEmailIdSelectedToDelete(null)
    }

    const onSaveSignature = async () => {
        if (!selectedRegisteredEmail?.value) {
            toast.show({
                title: 'Warning',
                description: 'Please Register Your Email',
            })
            return
        }
        // const editorContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        // const plainText = editorState.getCurrentContent().getPlainText();

        const contentState = editorState.getCurrentContent();
        const plainText = contentState.getPlainText();

        // if (!plainText) {
        //     toast.show({
        //         title: 'Warning',
        //         description: 'Please Add Signature!',
        //     })
        //     return
        // }

        const editorContent = draftToHtml(convertToRaw(contentState));


        dispatch(addEmailSignature({ notes: editorContent, registeredEmailId: selectedRegisteredEmail?.value })).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Successfully Added Email Signature',
            })
        }).catch(err => {
            if (err?.response?.data?.message === "No Payload") {
                toast.show({
                    title: 'Warning',
                    description: 'Register Your Email First',
                })
                return
            }
            toast.show({
                title: 'Warning',
                description: 'Unable To Add Email Signature',
            })
            return
        })

        await getSavedEmailsAndSettingsDataForUser()
    }

    // const onSaveVoicemail = async () => {
    //     if (voicemailMsg && selectedOption) {
    //         await dispatch(addVoicemail({ selectedOption, voicemailMsg })).then(() => {
    //             toast.show({
    //                 title: 'Success',
    //                 description: 'Successfully Added Voicemail Details',
    //             })
    //         }).catch(err => {
    //             toast.show({
    //                 title: 'Warning',
    //                 description: 'Unable To Add Voicemail Details',
    //             })
    //         })
    //     } else {
    //         toast.show({
    //             title: 'Warning',
    //             description: 'No Voicemail Details Added',
    //         })
    //     }

    //     await getUserInfoHandler()
    // }

    const getUserInfoHandler = useCallback(async () => {
        await dispatch(getUserInfo(user?.id)).then((res) => {
            setSelectedOption(res?.info?.voiceMailType)
            setVoicemailMsg(res?.info?.voiceMailMessage)
            setPhoneNo({
                label: res?.info?.assignedPhoneNumber,
                value: res?.info?.assignedPhoneNumber
            })
            setSelectedOption(res?.info?.voiceMailType)
        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: 'Unable To Get The Updated Voicemail',
            })
        })
    })

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };

    const onShowDeleteWarning = (data) => {
        setEmailIdSelectedToDelete(data)
    }

    const Option = (props) => {
        const { data, selectProps } = props
        return (
            <div>
                <components.Option {...props}>
                    <div className="d-flex justify-content-between">
                        <p>{data?.label}</p>
                        <div className="d-flex justify-content-between align-item-center column-gap-4">
                            {data?.isDefault && <p className="m-0 d-flex align-items-center fw-bold" style={{ color: '#214466' }}>( Default )</p>}
                            {selectProps?.id === 'selectDefaultEmail' ? null : <i class="bi bi-trash fs-2 text-danger" onClick={() => { onShowDeleteWarning(data) }} />}
                        </div>
                    </div>
                </components.Option>
            </div>
        );
    };

    useEffect(() => {
        if (location?.state !== undefined) {
            dispatch(exchangeCodeForTokens(location?.state?.code)).then(async (res) => {
                await dispatch(saveAuthenticatedEmail({ email: res?.userInfo, accessToken: res.access_token, refreshToken: res.refresh_token, expires_in: res.expires_in, domain: 'google', emailSyncDuration: selectedSyncDuration?.name })).then(async (res) => {
                    toast.show({
                        title: 'Success',
                        description: 'Authenticated Successfully',
                    })
                    await getSavedEmailsAndSettingsDataForUser()
                }).catch(err => {
                    toast.show({
                        title: 'Warning',
                        description: 'Error occoured while saving email',
                    })
                })
            }).catch(err => {
                toast.show({
                    title: 'Warning',
                    description: 'Error occoured',
                })
            })
        }
    }, [location?.state])

    const onGoogleClicked = () => {
        setIsOpenGoogleLinkDuration(!isOpenGoogleLinkDuration)
        setIsOpenMicrosoftLinkDuration(false)
        setEmailDomain('google')
    }

    const onMicrosoftClicked = () => {
        setIsOpenMicrosoftLinkDuration(!isOpenMicrosoftLinkDuration)
        setIsOpenGoogleLinkDuration(false)
        setEmailDomain('microsoft')
    }



    const selectRegisteredEmailHandler = (e) => {
        setSelectedRegisteredEmail(e)

        let tmpSelectedEmailSignature = userAppSettingData?.allEmails?.filter((data) => data?.id === e?.value)
        if (tmpSelectedEmailSignature[0]?.emailSignature) {
            const contentBlock = htmlToDraft(tmpSelectedEmailSignature[0]?.emailSignature);
            if (contentBlock) {
                const { contentBlocks, entityMap } = contentBlock;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                const newEditorState = EditorState.createWithContent(contentState);
                setEditorState(newEditorState);
            } else {
                setEditorState(EditorState.createEmpty())
            }
        } else {
            setEditorState(EditorState.createEmpty())
        }
    }

    const onSavePhoneNo = async () => {
        dispatch((updatePhoneNo(phoneNo?.value))).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Updated Phone Number Successfully',
            })
        }).catch((err) => {
            toast.show({
                title: 'Danger',
                description: 'Unable To Update Phone Number',
            })
        })
    }

    const handleImageUpload = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                resolve({ data: { link: event.target.result } }); // Base64 URL
            };
            reader.onerror = (err) => {
                reject(err);
            };
            reader.readAsDataURL(file);
        });
    };

    useEffect(() => {
        setEditorState(EditorState.createEmpty())
        getSavedEmailsAndSettingsDataForUser()
        getUserInfoHandler()
    }, [])

    return (
        <div className="row d-flex justify-content-between row-gap-5 h-100 px-5">
            <div className="col-12 h-100 px-4">
                <Title title={'Email Settings'} />
                <div className="border mt-5 py-5 px-4" style={{ height: '400px', zIndex: 10, height: 'auto' }}>
                    <Modal
                        backdrop='static'
                        className="advance-acceptance-details-modal"
                        show={emailIdSelectedToDelete ? true : false}
                        // show={true }

                        size="md"
                        // onClick={() => { }}
                        onHide={() => { setEmailIdSelectedToDelete(null) }}
                    >
                        <Modal.Header>
                            <Modal.Title className='text-danger fw-bold h3 text-center'>
                                Warning
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="fs-3 d-flex flex-column align-items-center ">
                            <p>Are you sure you want to delete this {emailIdSelectedToDelete?.isDefault ? 'default' : ''} email <span className="fw-bold" style={{ color: '#214466' }}>{emailIdSelectedToDelete?.name}</span>?</p>
                            {
                                emailIdSelectedToDelete?.isDefault && (
                                    <div className="col-4 text-center">
                                        {userEmailList?.length > 2 && <p className="fs-4 fw-bold" style={{ color: '#214466' }}>Please Select Your Default Email</p>}
                                        {userEmailList?.length > 2 &&
                                            userEmailList?.map((email) => {
                                                if (email?.isDefault) {
                                                    return null
                                                }

                                                return (
                                                    <label style={{ fontSize: 14, fontWeight: 400 }} className="text-black d-flex align-item-center" >
                                                        <input
                                                            className="me-3 ms-4"
                                                            type="radio"
                                                            value={email?.value}
                                                            checked={parseInt(selectedOption) === parseInt(email?.value)}

                                                            onChange={(e) => { handleOptionChange(e) }}
                                                        />
                                                        {email?.name}
                                                    </label>
                                                )
                                            })
                                        }

                                    </div>
                                )
                            }
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center column-gap-4">
                            <button className="report_small_button_grey" onClick={() => { setEmailIdSelectedToDelete(null) }}>Cancel</button>
                            <button className="report_small_button_danger" onClick={onDeleteEmail}>Delete</button>
                        </Modal.Footer>
                    </Modal>

                    <div className=" d-flex">
                        <div className="d-flex flex-column row-gap-3 col-4">
                            <Label label={'Connected Emails'} />
                            <Select
                                className=""
                                options={userEmailList}
                                value={selectedRegisteredEmail || {}}
                                onChange={(e) => { selectRegisteredEmailHandler(e) }}
                                styles={customStyles}
                                components={{ Option }}
                            />
                        </div>
                        <div className="d-flex flex-column row-gap-3 col-4 offset-4">
                            <Label label={'Select Your Default Email'} />
                            <Select
                                id='selectDefaultEmail'
                                className=""
                                options={userEmailList}
                                value={defaultEmail || {}}
                                onChange={(e) => { onDefaultEmailHandler(e) }}
                                styles={customStyles}
                                components={{ Option }}
                            />
                        </div>
                    </div>


                    <div className="d-flex column-gap-5 mt-5 " style={{ marginTop: 200, height: '300px' }}>
                        <div className="d-flex flex-column row-gap-3 w-100 h-100">
                            <Label label='Email Signature' />
                            <div className="border  rounded w-100 h-100" style={{ height: '200px', width: '100%' }}>
                                <Editor
                                    editorStyle={{
                                        padding: 10,
                                        height: '100px',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box',
                                        overflowX: 'hidden', // Prevents horizontal overflow
                                        wordWrap: 'break-word', // Ensures wrapping of long words/URLs
                                        whiteSpace: 'normal',
                                        img: {
                                            display: 'block',
                                            marginLeft: '0',  // Ensures image is aligned to the left
                                            marginRight: 'auto',  // Automatically gives left alignment
                                        },
                                    }}
                                    editorState={editorState}
                                    toolbarClassName={`supplier-history-editor-toolbar`}
                                    wrapperClassName="supplier-history-editor-wrapper flex flex-column"
                                    editorClassName="supplier-history-editor h5 no-scrollbar"
                                    onEditorStateChange={onEditorStateChange}
                                    placeholder="Start typing here..."
                                    toolbar={{
                                        image: {
                                            uploadCallback: handleImageUpload,
                                            alt: { present: true, mandatory: false },
                                            defaultSize: { height: '50px !important', width: '30px !important' },
                                            alignment: 'left',
                                            previewImage: true,
                                            alignmentEnabled: true
                                        },
                                        options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'image', 'remove', 'history'], // Make sure 'image' is in the options list
                                        // image: {
                                        //     // icon: image,
                                        //     className: undefined,
                                        //     component: undefined,
                                        //     popupClassName: undefined,
                                        //     urlEnabled: true,
                                        //     uploadEnabled: true,
                                        //     alignmentEnabled: true,
                                        //     uploadCallback: undefined,
                                        //     previewImage: false,
                                        //     inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                        //     alt: { present: false, mandatory: false },
                                        //     defaultSize: {
                                        //       height: 'auto',
                                        //       width: 'auto',
                                        //     },
                                        //     uploadCallback: handleImageUpload,
                                        //   },
                                    }}
                                />
                            </div>
                            <div className="d-flex justify-content-end">
                                <button className="report_button_success px-5" onClick={onSaveSignature} style={{ width: 'auto' }}>Save Signature</button>
                            </div>
                        </div>
                    </div>

                    <div className=" d-flex flex-column justify-content-between mt-2 row-gap-3 " style={{ zIndex: 20 }}>
                        <Label label='Link New Account' />
                        <div className="d-flex align-items-start column-gap-5 " style={{ height: 45, borderRadius: '5px' }} >
                            <div className=" d-flex column-gap-1 position-relative">
                                <button className='border rounded-circle p-3' onClick={onGoogleClicked}><FcGoogle size={30} /></button>;
                                <div className="position-absolute" style={{ left: 20, top: 60, }}>
                                    <LinkAccount
                                        linkOptions={linkOptions}
                                        isOpenGoogleLinkDuration={isOpenGoogleLinkDuration}
                                        setIsOpenGoogleLinkDuration={setIsOpenGoogleLinkDuration}
                                        customStyles={customStyles}
                                        setSelectedSyncDuration={setSelectedSyncDuration}
                                        selectedSyncDuration={selectedSyncDuration}
                                        onAddEmails={onAddEmails}
                                    />
                                </div>
                            </div>
                            <div className=" d-flex column-gap-1 position-relative">
                                <button className='border rounded-circle p-3' onClick={onMicrosoftClicked}><FaMicrosoft size={25} color="#104569" /></button>;
                                <div className="position-absolute" style={{ left: 20, top: 60, }}>
                                    <LinkAccount
                                        linkOptions={linkOptions}
                                        isOpenMicrosoftLinkDuration={isOpenMicrosoftLinkDuration}
                                        setIsOpenMicrosoftLinkDuration={setIsOpenMicrosoftLinkDuration}
                                        customStyles={customStyles}
                                        setSelectedSyncDuration={setSelectedSyncDuration}
                                        selectedSyncDuration={selectedSyncDuration}
                                        onAddEmails={onAddEmails}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppEmail;